import { bloqueioBilhetesSenha } from './../../../../core/config/app.config';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-codigodeacesso',
  templateUrl: './codigodeacesso.component.html',
  styleUrls: ['./codigodeacesso.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CodigodeacessoComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<CodigodeacessoComponent>, private toastr: ToastrService) { }

    public titulo: string;
    public mensagem: string;
    public codigo: string = '';
    public formulario: FormGroup;
    ngOnInit(): void {
        this.titulo = this.data.titulo;
        this.mensagem = this.data.mensagem;
        this.formulario = new FormGroup({
            senha: new FormControl('', Validators.required)
        });
    }

    confirmar() {
        if(this.formulario.value.senha == bloqueioBilhetesSenha){
            this.dialogRef.close("Confirmar");
        }else{
            this.toastr.error(
                "Código inválido",
                "Código"
            );
        }

    }

}
